export default __webpack_public_path__ + "88c1e07596e8cec2347bf87f16c4b001.ico";